import { render, staticRenderFns } from "./SwapNotification.vue?vue&type=template&id=733b00b0&scoped=true&"
import script from "./SwapNotification.vue?vue&type=script&lang=ts&"
export * from "./SwapNotification.vue?vue&type=script&lang=ts&"
import style0 from "./SwapNotification.vue?vue&type=style&index=0&id=733b00b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733b00b0",
  null
  
)

export default component.exports